import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSchoolProfile } from '../../Services/configService';

// Async thunk for fetching school profile
export const fetchSchoolProfile = createAsyncThunk(
  'schoolProfile/fetchSchoolProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSchoolProfile();
      if (response.status !== 'success') {
        return rejectWithValue('Failed to fetch school profile');
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  profile: null,
  loading: false,
  error: null,
};

const schoolProfileSlice = createSlice({
  name: 'schoolProfile',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearProfile: (state) => {
      state.profile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchoolProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchSchoolProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearProfile } = schoolProfileSlice.actions;

export const selectSchoolProfile = (state) => state.schoolProfile.profile;
export const selectSchoolProfileLoading = (state) => state.schoolProfile.loading;
export const selectSchoolProfileError = (state) => state.schoolProfile.error;

export default schoolProfileSlice.reducer;